import { render, staticRenderFns } from "./UserMailVerification.vue?vue&type=template&id=0fcbe4a4&"
import script from "./UserMailVerification.vue?vue&type=script&lang=js&"
export * from "./UserMailVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports